import {
  Exercise,
  ExerciseCollection,
} from "@/components/workouts/workoutsColumns";
import { v4 as uuidv4 } from "uuid";

export function exercisesToExerciseCollection(
  exercises: any[]
): ExerciseCollection[] {
  const ex = exercises.sort((a, b) => (a.ex_order ?? 0) - (b.ex_order ?? 0));

  // Group exercises by ex_order and then sort by sub order
  const exerciseCollection: ExerciseCollection[] = [];
  ex.forEach((exercise) => {
    const ex = exercise as Exercise;
    const order = exercise.ex_order ?? 0;

    if (exerciseCollection.length === order) {
      exerciseCollection.push([{ ...ex, sortableId: uuidv4() }]);
    } else {
      exerciseCollection[order].push({ ...ex, sortableId: uuidv4() });
      exerciseCollection[order].sort(
        (a, b) => (a.sub_order ?? 0) - (b.sub_order ?? 0)
      );
    }
  });

  return exerciseCollection;
}
